import { Hidden as MuiHidden } from '@material-ui/core'

import type { HiddenProps } from './types'

export function Hidden(props: HiddenProps) {
  const { children, ...rest } = props

  return <MuiHidden {...rest}>{children}</MuiHidden>
}
